import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement chancen-component-card-title
 */
@customElement('chancen-component-card-title')
export class ChancenComponentCardTitle extends ChemistryLitElement {
  override render() {
    return html` <cr-flex
      horizontal
      space-between
      ${css({
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        paddingBottom: this.spacing.sm,
        alignItems: 'center',
      })}
    >
      <cr-text bold><slot></slot></cr-text>
      <slot name="right">
        <cr-text bold></cr-text>
      </slot>
    </cr-flex>`;
  }
}
